<script setup>
import PricingPlanTabs from './PricingPlanTabs.vue';
</script>

<template>
    <div class="flex flex-col items-center justify-center py-10">
        <div class="mb-5 text-center text-xl font-bold text-[#191A15]  sm:mb-6 sm:text-3xl md:mb-10 md:text-4xl lg:text-5xl lg:leading-tight">
            Choose a Plan <br> That's Right For Your Market
        </div>
        <div class="text-md text-center font-semibold text-primary-gray md:text-lg">
            Choose plan that works best for you, feel free to <br> contact us or you can
        </div>
        <div class="text-center">
            <a class="mx-auto w-full max-w-[260px]" href="/registration">
                <button class="inline-flex items-center justify-center whitespace-nowrap ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 underline-offset-4 hover:underline dark:text-slate-50 h-12 text-md mx-auto w-full max-w-[260px] rounded-[20px] px-4 py-8 font-semibold text-[#00803A] underline md:text-xl">Create Market</button>
            </a>
        </div>
        <PricingPlanTabs />
    </div>
</template>